// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3_Opg","info":"Note_info__2OnN7","note":"Note_note__utFhb","actions":"Note_actions__1CUXR"};